<template>
  <v-container style="padding:10px;">
    <h2 style="font-size:18px;">{{$t('Setting')}}</h2>

    <v-container grid-list-md style="padding:0px;">
      <v-layout wrap>
        <!-- Restaurant Logo -->
        <v-flex v-if="showAboutUs" xs6>
          <h4 class="inputTitle">{{$t('restLogoTitle')}}:</h4>

          <croppa
            v-model="croppaRestLogo"
            style="display:none;"
            :width="25"
            :height="25"
            :prevent-white-space="true"
            :show-remove-button="true"
            :disable-drag-and-drop="true"
            :disable-click-to-choose="true"
            :disable-drag-to-move="true"
            :disable-scroll-to-zoom="true"
            :show-loading="true"
            @file-choose="handleCroppaFileChoose"
            @new-image-drawn="handleNewImage('rLogo')"
          ></croppa>

          <button
            v-if="restLogo == ''"
            class="imgBorder"
            style="margin:5px;padding:20px;background-color:white;font-size:50px;border-radius:5px;"
          >+</button>

          <div>
            <img
              v-if="restLogo != ''"
              :v-model="restLogo"
              style="padding:5px; margin:5px;border:0.5px solid grey;border-radius:5px;width:48%;max-width:60px;"
              :src="restLogo"
            />
          </div>
          <button
            style="margin:0px 0px 0px 5px;width:40%;height:auto;background-color:#1976d2;color:white;font-size:14px;border-radius:5px;"
            @click="chooseMenuImg('restLogo')"
          >{{$t('Choose')}}</button>
          <button
            v-if="restLogo != ''"
            style="margin:0px 0px 0px 5px;width: 40%;height:25px;background-color:red;color:white;font-size:14px;border-radius:5px;"
            @click="clearRestImg()"
          >{{$t('Clear')}}</button>
        </v-flex>

        <!-- Banner Image -->
        <v-flex v-if="showAboutUs" xs6>
          <croppa
            v-model="croppaBanner"
            style="display:none;"
            :width="bnrW"
            :height="bnrH"
            :prevent-white-space="true"
            :show-remove-button="true"
            :disable-drag-and-drop="true"
            :disable-click-to-choose="true"
            :disable-drag-to-move="true"
            :disable-scroll-to-zoom="true"
            :show-loading="true"
            @file-choose="handleCroppaFileChoose"
            @new-image-drawn="handleNewImage('banner')"
          ></croppa>

          <h4 class="inputTitle">{{$t('bannerImgTitle')}}:</h4>

          <button
            v-if="bannerImg == ''"
            class="imgBorder"
            style="margin:5px;padding:20px;background-color:white;font-size:50px;border-radius:5px;"
          >+</button>

          <div>
            <img
              v-if="bannerImg != ''"
              :v-model="bannerImg"
              style="padding:5px; margin:5px;border:0.5px solid grey;border-radius:5px;width:100%;"
              :src="bannerImg"
            />
          </div>
          <button
            style="margin:0px 0px 0px 5px;width:40%;height:auto;background-color:#1976d2;color:white;font-size:14px;border-radius:5px;"
            @click="chooseMenuImg('bannerImg')"
          >{{$t('Choose')}}</button>
          <button
            v-if="bannerImg != ''"
            style="margin:0px 0px 0px 5px;width: 40%;height:25px;background-color:red;color:white;font-size:14px;border-radius:5px;"
            @click="clearBannerImg()"
          >{{$t('Clear')}}</button>
          <p v-if="errImgWithTran != ''" class="txtClrRed">{{$t(errImgWithTran)}}</p>
        </v-flex>

        <!-- About Us -->
        <v-flex v-if="showAboutUs" xs12>
          <h4 class="inputTitle">{{$t('AboutUs')}} : ({{$t('Max')}} 500 {{$t('Character')}})</h4>
          <textarea
            v-model="sAboutUs"
            rows="5"
            maxlength="500"
            class="form-control"
            name="sAboutUs"
            required
            autocomplete="nope"
            type="text"
            @input="sAboutUs = $event.target.value"
          />
        </v-flex>
      </v-layout>

      <!-- Google Map -->
      <h4 v-if="showLocMap" class="inputTitle">{{$t('GoogleMap')}} :</h4>
      <vue-google-autocomplete
        v-if="showLocMap"
        id="map"
        ref="gMapInput"
        class="form-control"
        placeholder="Enter Location"
        @placechanged="getAddressData"
      ></vue-google-autocomplete>

      <div
        v-if="showLocMap"
        id="map"
        ref="map"
        style="height:450px;background:grey;margin-top:10px;margin-bottom:10px;"
        @click="chgMapPosition()"
      ></div>

      <v-layout wrap>
        <!-- Company Info -->
        <v-flex
          v-if="showCmpName || showCmpEmail || showCmpPh || showCmpAddress || showCmpWeb"
          xs12
        >
          <p style="margin:0px;">{{$t('CompanyInfo')}} :</p>
        </v-flex>
        <v-layout
          v-if="showCmpName || showCmpEmail || showCmpPh || showCmpAddress || showCmpWeb"
          wrap
          style="border: 0.5px solid grey;border-radius:5px;padding:5px;margin-bottom:10px;"
        >
          <!-- Company Name -->
          <v-flex v-if="showCmpName" xs12>
            <h4 class="inputTitle">{{$t('Name')}} : ({{$t('Max')}} 100 {{$t('Character')}})</h4>
            <input
              v-model="sCmpName"
              class="form-control"
              required
              maxlength="100"
              autocomplete="nope"
              type="text"
              name="sCmpName"
              @input="sCmpName = $event.target.value"
            />
          </v-flex>

          <!-- Company Email -->
          <v-flex v-if="showCmpEmail" xs12>
            <h4 class="inputTitle">{{$t('Email')}} : ({{$t('Max')}} 100 {{$t('Character')}})</h4>
            <input
              v-model="sCmpEmail"
              class="form-control"
              required
              maxlength="100"
              autocomplete="nope"
              type="text"
              name="sCmpEmail"
              @input="sCmpEmail = $event.target.value"
            />
          </v-flex>

          <!-- Company Phone Number -->
          <v-flex v-if="showCmpPh" xs12>
            <h4 class="inputTitle">{{$t('PhoneNumber')}} : ({{$t('Max')}} 60 {{$t('Character')}})</h4>
            <input
              v-model="sCmpPh"
              class="form-control"
              required
              maxlength="60"
              autocomplete="nope"
              type="tel"
              name="sCmpPh"
              @input="sCmpPh = $event.target.value.replace(/[^0-9]/g,'')"
            />
          </v-flex>

          <!-- Company Address -->
          <v-flex v-if="showCmpAddress" xs12>
            <h4 class="inputTitle">{{$t('Address')}} : ({{$t('Max')}} 500 {{$t('Character')}})</h4>
            <textarea
              v-model="sCmpAddress"
              type="text"
              rows="5"
              maxlength="500"
              class="form-control"
              name="sCmpAddress"
              autocomplete="nope"
              @input="sCmpAddress = $event.target.value"
            />
          </v-flex>

          <!-- Company Website -->
          <v-flex v-if="showCmpWeb" xs12>
            <h4 class="inputTitle">{{$t('Website')}} : ({{$t('Max')}} 100 {{$t('Character')}})</h4>
            <input
              v-model="sCmpWeb"
              class="form-control"
              required
              maxlength="100"
              autocomplete="nope"
              type="text"
              name="sCmpWeb"
              @input="sCmpWeb = $event.target.value"
            />
          </v-flex>
        </v-layout>

        <!-- Templete Url -->
        <v-flex v-if="showTempleteUrl" xs12>
          <h4 class="inputTitle">{{$t('TempleteUrl')}} :</h4>
          <input
            v-model="sTempleteUrl"
            class="form-control"
            required
            maxlength="50"
            autocomplete="nope"
            type="text"
            name="sTempleteUrl"
            @input="sTempleteUrl = $event.target.value"
          />
        </v-flex>

        <!-- Price Rate Msg -->
        <v-flex v-if="showPriceRateMsg" xs12>
          <h4 class="inputTitle">{{$t('PriceRateMsg')}} : ({{$t('Max')}} 500 {{$t('Character')}})</h4>
          <input
            v-model="sPriceRateMsg"
            class="form-control"
            required
            maxlength="500"
            autocomplete="nope"
            type="text"
            name="sPriceRateMsg"
            @input="sPriceRateMsg = $event.target.value"
          />
        </v-flex>

        <!-- Svc Percent -->
        <v-flex v-if="showSvcPercent" xs12>
          <h4 class="inputTitle">{{$t('SvcPercent')}} :</h4>
          <input
            v-model="sSvcPercent"
            style="width:100%;"
            class="form-control"
            required
            autocomplete="nope"
            type="number"
            name="sSvcPercent"
            @input="sSvcPercent = $event.target.value"
          />
        </v-flex>

        <!-- Tax Percent -->
        <v-flex v-if="showTaxPercent" xs12>
          <h4 class="inputTitle">{{$t('TaxPercent')}} :</h4>
          <input
            v-model="sTaxPercent"
            class="form-control"
            style="width:100%;"
            required
            autocomplete="nope"
            type="number"
            name="sTaxPercent"
            @input="sTaxPercent = $event.target.value"
          />
        </v-flex>

        <!-- Schd Type -->
        <v-flex
          v-if="showCanDineIn || showCanTakeAway || showCanDelivery || showCanScanAndOrder"
          xs12
        >
          <p style="margin:0px;">{{$t('SchdType')}} :</p>
        </v-flex>
        <v-layout
          v-if="showCanScanAndOrder || showBtnNameScanOrder"
          wrap
          style="border: 0.5px solid grey;border-radius:5px;padding:5px;width:100%;"
        >
          <v-flex v-if="showCanScanAndOrder" xs5>
            <v-checkbox
              v-model="sCanScanAndOrder"
              style="color:black;margin: 0px;margin-top: 20px;"
              color="primary"
              :label="$t('ScanAndOrder')"
            ></v-checkbox>
          </v-flex>

          <!-- Btn Name Scan Order -->
          <v-flex v-if="showBtnNameDelivery && sCanScanAndOrder" xs7>
            <h4 class="inputTitle" style="margin-top:0px;">{{$t('ScanOrderBtnName')}} :</h4>
            <input
              v-model="sBtnNameScanOrder"
              class="form-control"
              required
              maxlength="100"
              style="width:100%;"
              autocomplete="nope"
              type="text"
              name="sBtnNameScanOrder"
              @input="sBtnNameScanOrder = $event.target.value"
            />
          </v-flex>
        </v-layout>

        <v-layout
          v-if="showCanDineIn || showBtnNameDineIn"
          wrap
          style="border: 0.5px solid grey;border-radius:5px;padding:5px;width:100%;"
        >
          <v-flex v-if="showCanDineIn" xs5>
            <v-checkbox
              v-model="sCanDineIn"
              style="color:black;margin: 0px;margin-top: 20px;"
              color="primary"
              :label="$t('DineIn')"
            ></v-checkbox>
          </v-flex>

          <!-- Btn Name Dine In -->
          <v-flex v-if="showBtnNameDineIn && sCanDineIn" xs7>
            <h4 class="inputTitle" style="margin-top:0px;">{{$t('DineInBtnName')}} :</h4>
            <input
              v-model="sBtnNameDineIn"
              class="form-control"
              required
              maxlength="100"
              style="width:100%;"
              autocomplete="nope"
              type="text"
              name="sBtnNameDineIn"
              @input="sBtnNameDineIn = $event.target.value"
            />
          </v-flex>
        </v-layout>

        <v-layout
          v-if="showCanTakeAway || showBtnNameTakeAway"
          wrap
          style="border: 0.5px solid grey;border-radius:5px;padding:5px;width:100%;"
        >
          <v-flex v-if="showCanTakeAway" xs5>
            <v-checkbox
              v-model="sCanTakeAway"
              style="color:black;margin: 0px;margin-top: 20px;"
              color="primary"
              :label="$t('TakeAway')"
            ></v-checkbox>
          </v-flex>

          <!-- Btn Name Take Away -->
          <v-flex v-if="showBtnNameTakeAway && sCanTakeAway" xs7>
            <h4 class="inputTitle" style="margin-top:0px;">{{$t('TakeAwayBtnName')}} :</h4>
            <input
              v-model="sBtnNameTakeAway"
              class="form-control"
              required
              maxlength="100"
              style="width:100%;"
              autocomplete="nope"
              type="text"
              name="sBtnNameTakeAway"
              @input="sBtnNameTakeAway = $event.target.value"
            />
          </v-flex>
        </v-layout>

        <v-layout
          v-if="showCanDelivery || showBtnNameDelivery"
          wrap
          style="border: 0.5px solid grey;border-radius:5px;padding:5px;width:100%;"
        >
          <v-flex v-if="showCanDelivery" xs5>
            <v-checkbox
              v-model="sCanDelivery"
              style="color:black;margin: 0px;margin-top: 20px;"
              color="primary"
              :label="$t('Delivery')"
            ></v-checkbox>
          </v-flex>

          <!-- Btn Name Delivery -->
          <v-flex v-if="showBtnNameDelivery && sCanDelivery" xs7>
            <h4 class="inputTitle" style="margin-top:0px;">{{$t('DeliveryBtnName')}} :</h4>
            <input
              v-model="sBtnNameDelivery"
              class="form-control"
              required
              maxlength="100"
              style="width:100%;"
              autocomplete="nope"
              type="text"
              name="sBtnNameDelivery"
              @input="sBtnNameDelivery = $event.target.value"
            />
          </v-flex>
        </v-layout>

        <!-- Delivery Charges -->
        <v-flex v-if="showDeliveryChg" xs12>
          <h4 class="inputTitle">{{$t('DeliveryCharges')}} :</h4>
          <input
            v-model="sDeliveryChg"
            class="form-control"
            required
            style="width:100%;"
            autocomplete="nope"
            type="number"
            name="sDeliveryChg"
            @input="sDeliveryChg = $event.target.value"
          />
        </v-flex>

        <!-- WhatsApp Reply Msg -->
        <v-flex v-if="showWAReplyMsg" xs12>
          <h4
            class="inputTitle"
          >{{$t('WhatsAppReplyMsg')}} : ({{$t('Max')}} 100 {{$t('Character')}})</h4>
          <input
            v-model="sWAReplyMsg"
            class="form-control"
            required
            maxlength="100"
            style="width:100%;"
            autocomplete="nope"
            type="text"
            name="sWAReplyMsg"
            @input="sWAReplyMsg = $event.target.value"
          />
        </v-flex>

        <!-- Deposit Min Amt -->
        <v-flex v-if="showDepositMinAmt" xs12>
          <h4 class="inputTitle">{{$t('DepositMinAmt')}} :</h4>
          <input
            v-model="sDepositMinAmt"
            class="form-control"
            required
            style="width:100%;"
            autocomplete="nope"
            type="number"
            name="sDepositMinAmt"
            @input="sDepositMinAmt = $event.target.value"
          />
        </v-flex>

        <!-- Deposit Percent -->
        <v-flex v-if="showDepositPercent" xs12>
          <h4 class="inputTitle">{{$t('DepositPercent')}} :</h4>
          <input
            v-model="sDepositPercent"
            class="form-control"
            required
            style="width:100%;"
            autocomplete="nope"
            type="number"
            name="sDepositPercent"
            @input="sDepositPercent = $event.target.value"
          />
        </v-flex>

        <!-- Rounding Type -->
        <v-flex v-if="showRoundingType" xs12>
          <p style="margin:0px;">{{$t('RoundingType')}} :</p>
          <v-select
            v-model="sRoundingType"
            style="padding:0px;max-height:40px;"
            class="stallInput"
            :items="roundingTypeList"
            required
            outline
            @input="onSelectRoundingType"
          ></v-select>
        </v-flex>

        <!-- No Item Msg -->
        <v-flex v-if="showNoItemMsg" xs12>
          <h4 class="inputTitle">{{$t('NoItemMsg')}} :</h4>
          <input
            v-model="sNoItemMsg"
            class="form-control"
            required
            maxlength="100"
            style="width:100%;"
            autocomplete="nope"
            type="text"
            name="sNoItemMsg"
            @input="sNoItemMsg = $event.target.value"
          />
        </v-flex>

        <!-- Option -->
        <v-flex v-if="showOption" xs12>
          <p style="margin:0px;">{{$t('Option')}} :</p>
        </v-flex>
        <v-layout
          v-if="showOption"
          wrap
          style="border: 0.5px solid grey;border-radius:5px;padding:5px;"
        >
          <v-flex xs6>
            <v-checkbox
              v-model="needPayment"
              style="color:black;margin: 0px;"
              color="primary"
              :label="$t('NeedPayment')"
            ></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              v-model="askLoginBeforeCheckout"
              style="color:black;margin: 0px;"
              color="primary"
              :label="$t('AskLoginBeforeCheckout')"
            ></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              v-model="ScanOrderMustEnterInfo"
              style="color:black;margin: 0px;"
              color="primary"
              :label="$t('ScanOrderMustEnterInfo')"
            ></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              v-model="foodCourtMode"
              style="color:black;margin: 0px;"
              color="primary"
              :label="$t('FoodCourtMode')"
            ></v-checkbox>
          </v-flex>
        </v-layout>

        <!-- chat Setting -->
        <v-flex v-if="showChatAccHdrToken || showUserAccToken" xs12>
          <p style="margin:0px;margin-top:10px;">{{$t('Token')}} :</p>
        </v-flex>
        <v-layout
          v-if="showChatAccHdrToken || showUserAccToken"
          xs12
          wrap
          style="border: 0.5px solid grey;border-radius:5px;padding:10px;"
        >
          <!-- Chat Acc Hdr Token -->
          <v-flex v-if="showChatAccHdrToken" xs12>
            <h4
              class="inputTitle"
            >{{$t('ChatAccountToken')}} : ({{$t('Max')}} 20 {{$t('Character')}})</h4>
            <input
              v-model="sChatAccHdrToken"
              class="form-control"
              required
              maxlength="20"
              autocomplete="nope"
              type="text"
              name="sChatAccHdrToken"
              @input="sChatAccHdrToken = $event.target.value"
            />
          </v-flex>

          <!-- User Acc Token -->
          <v-flex v-if="showUserAccToken" xs12>
            <h4 class="inputTitle">{{$t('UserAccToken')}} : ({{$t('Max')}} 20 {{$t('Character')}})</h4>
            <input
              v-model="sUserAccToken"
              class="form-control"
              required
              maxlength="20"
              autocomplete="nope"
              type="text"
              name="sUserAccToken"
              @input="sUserAccToken = $event.target.value"
            />
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
    <br />
    <span
      v-if="getMchtConfigError != ''"
      style="padding-left:16px;"
      class="txtClrRed"
    >{{getMchtConfigError}}</span>

    <v-btn style="float:right;" color="primary" @click="saveMchtConfig()">{{$t('Save')}}</v-btn>

    <v-layout class="text-xs-center">
      <v-dialog v-model="loadingDialog" persistent width="1000">
        <v-card height="200">
          <v-card-text>
            <br />
            <!-- <v-btn color="primary" style="float:right;" @click="closeLoadingDialog()">X</v-btn> -->
            <v-layout row wrap align-center>
              <v-progress-circular
                :size="100"
                :width="8"
                color="primary"
                indeterminate
                class="progress-circular"
              ></v-progress-circular>
            </v-layout>
            <div>
              <h3 class="loadingMsg">{{$t('InProgressPleaseWaitAMoment')}}</h3>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout class="text-xs-center">
      <v-dialog v-model="clearRestLogoDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text>
            <h3>{{$t('sureToRemoveRestImageTxt')}}</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="sureDltImg('rest')">{{$t('Yes')}}</v-btn>
            <v-btn color="primary" flat @click="clearRestLogoDialog = false">{{$t('No')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout class="text-xs-center">
      <v-dialog v-model="cleaBannerDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text>
            <h3>{{$t('sureToRemoveBannerImageTxt')}}</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="sureDltImg('banner')">{{$t('Yes')}}</v-btn>
            <v-btn color="primary" flat @click="cleaBannerDialog = false">{{$t('No')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout class="text-xs-center">
      <v-dialog v-model="recordSaveDialog" persistent width="300">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            color="primary-title"
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text style="padding-top:5px;padding-bottom:0px;">
            <h2 style="margin:0px;">{{$t('RecordSuccessfullySaved')}}</h2>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" flat @click="recordSaveDialog = false">{{$t('Ok')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-container>
</template>

<script>
import JS from './JsonService'
import { getOrientation } from 'get-orientation/browser'
import { enumEOrder_MchOption } from './JsonKey.js'
import { translateErrorMsg } from './translateErrorMsg'
import VersionDialog from '../src/VersionNotMatchDialog'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import globalVar from './GlobalVar.js'
export default {
  components: {
    VersionDialog,
    VueGoogleAutocomplete
  },
  mixins: [translateErrorMsg],
  data() {
    return {
      roundingTypeList: ['0', '1', '2', '3', '4', '5'],
      sAboutUs: '',
      sTempleteUrl: '',
      sPriceRateMsg: '',
      sSvcPercent: 0,
      sTaxPercent: 0,
      sChatAccHdrToken: '',
      sUserAccToken: '',
      sCanDineIn: false,
      sCanTakeAway: false,
      sCanDelivery: false,
      sCanScanAndOrder: false,
      sDeliveryChg: 0,
      sWAReplyMsg: '',
      sDepositMinAmt: 0,
      sDepositPercent: 0,
      sRoundingType: '0',
      sOption: 0,
      sCmpName: '',
      sCmpEmail: '',
      sCmpPh: '',
      sCmpAddress: '',
      sCmpWeb: '',
      sBtnNameDineIn: '',
      sBtnNameTakeAway: '',
      sBtnNameDelivery: '',
      sBtnNameScanOrder: '',
      sNoItemMsg: 'No Item Found',

      showAboutUs: false,
      showTempleteUrl: false,
      showPriceRateMsg: false,
      showSvcPercent: false,
      showTaxPercent: false,
      showChatAccHdrToken: false,
      showUserAccToken: false,
      showCanDineIn: false,
      showCanTakeAway: false,
      showCanDelivery: false,
      showCanScanAndOrder: false,
      showDeliveryChg: false,
      showWAReplyMsg: false,
      showDepositMinAmt: false,
      showDepositPercent: false,
      showRoundingType: false,
      showOption: false,
      showCmpName: false,
      showCmpEmail: false,
      showCmpPh: false,
      showCmpAddress: false,
      showCmpWeb: false,
      showLocMap: false,
      showBtnNameDineIn: false,
      showBtnNameTakeAway: false,
      showBtnNameDelivery: false,
      showBtnNameScanOrder: false,
      showNoItemMsg: false,

      needPayment: false,
      askLoginBeforeCheckout: false,
      foodCourtMode: false,
      ScanOrderMustEnterInfo: false,

      IOption: 0,

      getMchtConfigError: '',
      loadingDialog: false,
      recordSaveDialog: false,
      versionError: false,

      restLogo: '',
      bannerImg: '',
      sltRestImgFile: [],
      sltBannerImgFile: [],
      errImgWithTran: '',
      clearRestLogoDialog: false,
      cleaBannerDialog: false,
      restLogoFromServer: '',
      bannerImgFromServer: '',
      deleteRestLogo: false,
      deleteBanner: false,

      croppaRestLogo: {},
      croppaBanner: {},
      croppaRestLogoFile: [],
      croppaBannerFile: [],
      sltedCroppa: '',

      map: null,
      locX: 0,
      locY: 0,
      gMapInput: '',
      bnrW: 500,
      bnrH: 500
    }
  },
  created: function() {
    this.getMchtConfig()
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    async onFileChanged(fileInput, val) {
      const orientation = await getOrientation(fileInput)
      console.log(orientation)
      //alert(orientation)
      if (val == 'rest') {
        this.changeOrientation(fileInput, 50, 50, orientation, 'rest')
      } else if (val == 'banner') {
        this.changeOrientation(fileInput, 1025, 350, orientation, 'banner')
      }
    },
    getAddressData: function(addressData) {
      // console.log(addressData)
      this.gMapInput = addressData

      this.map = new window.google.maps.Map(this.$refs['map'], {
        center: {
          lat: Number(addressData.latitude),
          lng: Number(addressData.longitude)
        },
        zoom: 17
      })

      var marker = new window.google.maps.Marker({
        position: {
          lat: Number(addressData.latitude),
          lng: Number(addressData.longitude)
        },
        map: this.map,
        draggable: true,
        animation: window.google.maps.Animation.DROP
      })

      this.locX = Number(addressData.latitude)
      this.locY = Number(addressData.longitude)

      const that = this
      window.google.maps.event.addListener(marker, 'dragend', function() {
        that.toggleBounce(marker.getPosition())
      })
    },
    chgMapPosition() {
      this.loadingDialog = true
      const that = this
      window.google.maps.event.addListener(this.map, 'click', function(
        mapsMouseEvent
      ) {
        var zoomLv = that.map.getZoom()
        that.map = new window.google.maps.Map(that.$refs['map'], {
          center: mapsMouseEvent.latLng,
          zoom: zoomLv
        })

        var marker = new window.google.maps.Marker({
          position: mapsMouseEvent.latLng,
          map: that.map,
          draggable: true,
          animation: window.google.maps.Animation.DROP
        })

        window.google.maps.event.addListener(marker, 'dragend', function() {
          that.toggleBounce(marker.getPosition())
        })

        //console.log(mapsMouseEvent.latLng.toString())
        const locXY = mapsMouseEvent.latLng
          .toString()
          .substring(1, mapsMouseEvent.latLng.toString().length - 1)
          .split(',')
        //console.log(locXY)
        that.locX = locXY[0]
        that.locY = locXY[1]
      })
      this.loadingDialog = false
    },
    handleCroppaFileChoose(val) {
      this.loadingDialog = true
      console.log(val)
      if (this.sltedCroppa == 'restLogo') {
        this.sltRestImgFile = val
      } else if (this.sltedCroppa == 'bannerImg') {
        this.sltBannerImgFile = val
      }
    },
    handleNewImage(cropName) {
      //console.log(this.myCroppa.$parent.chosenFile)
      if (cropName == 'rLogo') {
        var url = this.croppaRestLogo.generateDataUrl('image/jpeg', 0.8)
        // console.log(url)
        this.sltRestImgFile = this.base64toFile(
          this.sltRestImgFile.name.substr(
            0,
            this.sltRestImgFile.name.lastIndexOf('.')
          ) + '.jpeg',
          url
        )
        this.restLogo = url
      } else if (cropName == 'banner') {
        this.bnrW = Number(this.croppaBanner.naturalWidth)
        this.bnrH = Number(this.croppaBanner.naturalHeight)
        // console.log(this.croppaBanner.naturalWidth)
        // console.log(this.croppaBanner.naturalHeight)

        var url2 = this.croppaBanner.generateDataUrl('image/jpeg', 0.8)
        // console.log(url2)
        this.sltBannerImgFile = this.base64toFile(
          this.sltBannerImgFile.name.substr(
            0,
            this.sltBannerImgFile.name.lastIndexOf('.')
          ) + '.jpeg',
          url2
        )
        this.bannerImg = url2
      }
      this.loadingDialog = false
      //this.uploadCroppedImage()
    },
    chooseMenuImg(croppa) {
      this.sltedCroppa = croppa
      if (croppa == 'restLogo') {
        this.croppaRestLogo.chooseFile()
      } else if (croppa == 'bannerImg') {
        this.croppaBanner.chooseFile()
      }
    },
    removeMenuImg() {
      this.clearImgDialog = true
    },
    getMchtConfig() {
      this.loadingDialog = true
      this.versionError = false
      let mchCode = sessionStorage.getItem('backendMchCode')
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
      var version = sessionStorage.getItem('version')
      const url = 'Back/GetMchtConfig'
      const parameter = {
        av: version,
        kp: mchCode,
        m: userInfo.UserId
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            this.loadingDialog = false
            this.getMchtConfigError = ''
            this.setMchtData(response.data.ListOfMcht)
            this.showVisibleMcht(response.data.ListOfVisible)
          }
        })
        .catch(error => {
          console.log(error)
          this.getMchtConfigError = error
          this.versionError = false
          this.loadingDialog = false
        })
    },
    setMchtData(MchtList) {
      if (MchtList[0].mv != null && MchtList[0].mv != '') {
        this.restLogo = JS.checkImg(MchtList[0].mv)
      } else {
        this.restLogo = ''
      }
      if (MchtList[0].kq != null && MchtList[0].kq != '') {
        this.bannerImg = JS.checkImg(MchtList[0].kq)
      } else {
        this.bannerImg = ''
      }
      this.restLogoFromServer = this.restLogo
      this.bannerImgFromServer = this.bannerImg
      this.sAboutUs = MchtList[0].ks
      this.sTempleteUrl = MchtList[0].kr
      this.sPriceRateMsg = MchtList[0].ov
      this.sSvcPercent = MchtList[0].oe
      this.sTaxPercent = MchtList[0].od
      this.sChatAccHdrToken = MchtList[0].jx
      this.sUserAccToken = MchtList[0].bp
      this.sCanDineIn = MchtList[0].mo
      this.sCanTakeAway = MchtList[0].mp
      this.sCanDelivery = MchtList[0].mq
      this.sCanScanAndOrder = MchtList[0].ok
      this.sDeliveryChg = MchtList[0].rs
      this.sWAReplyMsg = MchtList[0].rt
      this.sDepositMinAmt = MchtList[0].ms
      this.sDepositPercent = MchtList[0].mt
      this.sRoundingType = MchtList[0].oy.toString()
      this.sOption = MchtList[0].ol
      this.locX = MchtList[0].bl
      this.locY = MchtList[0].bm
      this.sCmpName = MchtList[0].oz
      this.sCmpEmail = MchtList[0].ly
      this.sCmpPh = MchtList[0].y
      this.sCmpAddress = MchtList[0].en
      this.sCmpWeb = MchtList[0].sc
      if (MchtList[0].se != '') {
        this.sBtnNameDineIn = MchtList[0].se
      }
      if (MchtList[0].sf != '') {
        this.sBtnNameTakeAway = MchtList[0].sf
      }
      if (MchtList[0].sg != '') {
        this.sBtnNameDelivery = MchtList[0].sg
      }
      if (MchtList[0].si != '') {
        this.sBtnNameScanOrder = MchtList[0].si
      }
      if (MchtList[0].sh != '') {
        this.sNoItemMsg = MchtList[0].sh
      }

      this.getEachOption(this.sOption)
    },
    showVisibleMcht(VisibleList) {
      if (VisibleList.length > 0) {
        for (let i = 0; i < VisibleList.length; i++) {
          if (VisibleList[i] == 'ks') {
            this.showAboutUs = true
          } else if (VisibleList[i] == 'kr') {
            this.showTempleteUrl = true
          } else if (VisibleList[i] == 'ov') {
            this.showPriceRateMsg = true
          } else if (VisibleList[i] == 'oe') {
            this.showSvcPercent = true
          } else if (VisibleList[i] == 'od') {
            this.showTaxPercent = true
          } else if (VisibleList[i] == 'jx') {
            this.showChatAccHdrToken = true
          } else if (VisibleList[i] == 'bp') {
            this.showUserAccToken = true
          } else if (VisibleList[i] == 'mo') {
            this.showCanDineIn = true
          } else if (VisibleList[i] == 'mp') {
            this.showCanTakeAway = true
          } else if (VisibleList[i] == 'mq') {
            this.showCanDelivery = true
          } else if (VisibleList[i] == 'ok') {
            this.showCanScanAndOrder = true
          } else if (VisibleList[i] == 'rs') {
            this.showDeliveryChg = true
          } else if (VisibleList[i] == 'rt') {
            this.showWAReplyMsg = true
          } else if (VisibleList[i] == 'ms') {
            this.showDepositMinAmt = true
          } else if (VisibleList[i] == 'mt') {
            this.showDepositPercent = true
          } else if (VisibleList[i] == 'oy') {
            this.showRoundingType = true
          } else if (VisibleList[i] == 'ol') {
            this.showOption = true
          } else if (VisibleList[i] == 'oz') {
            this.showCmpName = true
          } else if (VisibleList[i] == 'ly') {
            this.showCmpEmail = true
          } else if (VisibleList[i] == 'y') {
            this.showCmpPh = true
          } else if (VisibleList[i] == 'en') {
            this.showCmpAddress = true
          } else if (VisibleList[i] == 'sc') {
            this.showCmpWeb = true
          } else if (VisibleList[i] == 'bl' || VisibleList[i] == 'bm') {
            this.showLocMap = true
          } else if (VisibleList[i] == 'se') {
            this.showBtnNameDineIn = true
          } else if (VisibleList[i] == 'sf') {
            this.showBtnNameTakeAway = true
          } else if (VisibleList[i] == 'sg') {
            this.showBtnNameDelivery = true
          } else if (VisibleList[i] == 'si') {
            this.showBtnNameScanOrder = true
          } else if (VisibleList[i] == 'sh') {
            this.showNoItemMsg = true
          }
        }
      } else {
        this.showAboutUs = true
        this.showTempleteUrl = true
        this.showPriceRateMsg = true
        this.showSvcPercent = true
        this.showTaxPercent = true
        this.showChatAccHdrToken = true
        this.showUserAccToken = true
        this.showCanDineIn = true
        this.showCanTakeAway = true
        this.showCanDelivery = true
        this.showCanScanAndOrder = true
        this.showDeliveryChg = true
        this.showWAReplyMsg = true
        this.showDepositMinAmt = true
        this.showDepositPercent = true
        this.showRoundingType = true
        this.showOption = true
        this.showCmpName = true
        this.showCmpEmail = true
        this.showCmpPh = true
        this.showCmpAddress = true
        this.showCmpWeb = true
        this.showLocMap = true
        this.showBtnNameDineIn = true
        this.showBtnNameTakeAway = true
        this.showBtnNameDelivery = true
        this.showBtnNameScanOrder = true
        this.showNoItemMsg = true
      }

      if (this.showLocMap) {
        let mapPromise = new Promise(resolve => {
          if (this.locX == 0 && this.locY == 0) {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(function(position) {
                var pos = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
                }
                console.log(pos)
                resolve(pos)
              })
            } else {
              var empty = {
                lat: 4.5693754,
                lng: 102.2656823
              }
              // Browser doesn't support Geolocation
              //console.log('doesnot get position')
              resolve(empty)
            }

            var blockPosition = {
              lat: 4.5693754,
              lng: 102.2656823
            }
            // Browser doesn't support Geolocation
            //console.log('doesnot get position')
            resolve(blockPosition)
          } else {
            //get location from serve
            var mapPosition = {
              lat: this.locX,
              lng: this.locY
            }
            resolve(mapPosition)
          }
        })

        mapPromise.then(data => {
          //console.log(data)

          this.map = new window.google.maps.Map(this.$refs['map'], {
            center: {
              lat: Number(data.lat),
              lng: Number(data.lng)
            },
            zoom: 17
          })

          var marker = new window.google.maps.Marker({
            position: {
              lat: Number(data.lat),
              lng: Number(data.lng)
            },
            draggable: true,
            animation: window.google.maps.Animation.DROP,
            map: this.map
          })

          this.locX = data.lat
          this.locY = data.lng

          const that = this
          window.google.maps.event.addListener(marker, 'dragend', function() {
            that.toggleBounce(marker.getPosition())
          })
        })
      }
    },
    toggleBounce(marker) {
      console.log(marker.toString())
      const locXY = marker
        .toString()
        .toString()
        .substring(1, marker.toString().toString().length - 1)
        .split(',')
      //console.log(locXY)
      this.locX = locXY[0]
      this.locY = locXY[1]
      var zoomLv = this.map.getZoom()
      this.map = new window.google.maps.Map(this.$refs['map'], {
        center: {
          lat: Number(this.locX),
          lng: Number(this.locY)
        },
        zoom: zoomLv
      })

      var newMarker = new window.google.maps.Marker({
        position: {
          lat: Number(this.locX),
          lng: Number(this.locY)
        },
        map: this.map,
        draggable: true,
        animation: window.google.maps.Animation.DROP
      })
      const that = this
      window.google.maps.event.addListener(newMarker, 'dragend', function() {
        that.toggleBounce(newMarker.getPosition())
      })
    },
    onSelectRoundingType(event) {
      console.log(event)
      this.sRoundingType = event
      console.log(this.sRoundingType)
    },
    getEachOption(option) {
      this.needPayment = this.checkNeedPayment(option)
      this.askLoginBeforeCheckout = this.checkAskLoginBeforeCheckout(option)
      this.foodCourtMode = this.checkUseFoodCourtMode(option)
      this.ScanOrderMustEnterInfo = this.checkUseScanOrderMustEnterInfo(option)
    },
    checkNeedPayment(lLevel) {
      console.log(lLevel)
      console.log([enumEOrder_MchOption.NeedPayment])
      console.log((lLevel & [enumEOrder_MchOption.NeedPayment]) != 0)
      return (lLevel & [enumEOrder_MchOption.NeedPayment]) != 0
    },
    checkAskLoginBeforeCheckout(lLevel) {
      console.log((lLevel & [enumEOrder_MchOption.AskLoginBeforeCheckout]) != 0)
      return (lLevel & [enumEOrder_MchOption.AskLoginBeforeCheckout]) != 0
    },
    checkUseFoodCourtMode(lLevel) {
      console.log((lLevel & [enumEOrder_MchOption.FoodCourtMode]) != 0)
      return (lLevel & [enumEOrder_MchOption.FoodCourtMode]) != 0
    },
    checkUseScanOrderMustEnterInfo(lLevel) {
      console.log((lLevel & [enumEOrder_MchOption.ScanOrderMustEnterInfo]) != 0)
      return (lLevel & [enumEOrder_MchOption.ScanOrderMustEnterInfo]) != 0
    },
    onRestFileSelected(val) {
      this.loadingDialog = true
      console.log(val)
      this.sltRestImgFile = val.target.files[0]
      console.log(this.sltRestImgFile)

      if (this.sltRestImgFile != '' && this.sltRestImgFile != undefined) {
        this.loadImgWH('rest')
      } else {
        this.loadingDialog = false
      }
    },
    onBannerFileSelected(val) {
      this.loadingDialog = true
      console.log(val)
      this.sltBannerImgFile = val.target.files[0]
      console.log(this.sltBannerImgFile)

      if (this.sltBannerImgFile != '' && this.sltBannerImgFile != undefined) {
        this.loadImgWH('banner')
      } else {
        this.loadingDialog = false
      }
    },
    loadImgWH(val) {
      var reader = new FileReader()
      var oriImg = new Image()
      let myFirstPromise = new Promise(resolve => {
        reader.onload = function(readerEvent) {
          oriImg.onload = function() {
            console.log(oriImg.width)
            console.log(oriImg.height)

            if (val == 'rest') {
              const WHInfo = { width: oriImg.width, height: oriImg.height }
              console.log(readerEvent.target.result)
              resolve(WHInfo)
            } else if (val == 'banner') {
              if (oriImg.height > oriImg.width) {
                resolve('The picture should be a horizontal rectangle!')
              } else {
                const WHInfo = { width: oriImg.width, height: oriImg.height }
                console.log(readerEvent.target.result)
                resolve(WHInfo)
              }
            }
          }
          oriImg.src = readerEvent.target.result
        }
        if (val == 'rest') {
          reader.readAsDataURL(this.sltRestImgFile)
        } else if (val == 'banner') {
          reader.readAsDataURL(this.sltBannerImgFile)
        }
      })

      myFirstPromise.then(Msg => {
        this.errImgWithTran = ''
        if (Msg.width) {
          //alert('real width:' + Msg.width + 'real height:' + Msg.height)
          console.log('real width:' + Msg.width + 'real height:' + Msg.height)
          this.oriImgWidth = Msg.width
          this.oriImgHeight = Msg.height
          if (val == 'rest') {
            this.restLogo = URL.createObjectURL(this.sltRestImgFile)
            console.log(this.sltRestImgFile)
            this.onFileChanged(this.sltRestImgFile, 'rest')
          } else if (val == 'banner') {
            this.bannerImg = URL.createObjectURL(this.sltBannerImgFile)
            console.log(this.sltBannerImgFile)
            this.onFileChanged(this.sltBannerImgFile, 'banner')
          }
        } else {
          this.loadingDialog = false
          console.log(Msg)
          this.errImgWithTran = translateErrorMsg.translateMsg(Msg)
        }
      })
    },
    changeOrientation(fileInput, w, h, orientation, val) {
      var img = new Image()
      if (val == 'rest') {
        img.src = this.restLogo
      } else if (val == 'banner') {
        img.src = this.bannerImg
      }

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      var exifOrientation = orientation

      var width = w,
        height = h

      // set proper canvas dimensions before transform & export
      if ([5, 6, 7, 8].indexOf(exifOrientation) > -1) {
        // canvas.width = height
        // canvas.height = width
        canvas.width = width
        canvas.height = height
      } else {
        canvas.width = width
        canvas.height = height
      }
      console.log('1.5 exifOrientation:', exifOrientation)
      // transform context before drawing image
      //alert(exifOrientation)
      switch (exifOrientation) {
        case 2:
          ctx.transform(-1, 0, 0, 1, width, 0)
          break
        case 3:
          ctx.transform(-1, 0, 0, -1, width, height)
          break
        case 4:
          ctx.transform(1, 0, 0, -1, 0, height)
          break
        case 5:
          ctx.transform(0, 1, 1, 0, 0, 0)
          break
        case 6:
          ctx.transform(0, 1, -1, 0, height, 0)
          this.oriImgWidth = this.oriImgHeight
          this.oriImgHeight = this.oriImgWidth
          break
        case 7:
          ctx.transform(0, -1, -1, 0, height, width)
          break
        case 8:
          ctx.transform(0, -1, 1, 0, 0, width)
          break
        default:
          ctx.transform(1, 0, 0, 1, 0, 0)
      }

      if (val == 'rest') {
        if (this.oriImgWidth > this.oriImgHeight) {
          this.diffX = (this.oriImgWidth - this.oriImgHeight) / 2
          this.diffY = 0
          this.diffOri = this.oriImgHeight
        } else if (this.oriImgHeight > this.oriImgWidth) {
          this.diffX = 0
          this.diffY = (this.oriImgHeight - this.oriImgWidth) / 2
          this.diffOri = this.oriImgWidth
        } else if (this.oriImgHeight == this.oriImgWidth) {
          this.diffX = 0
          this.diffY = 0
          this.diffOri = this.oriImgWidth
        }
      } else if (val == 'banner') {
        this.diffX = 0
        //this.diffY = (this.oriImgWidth - this.oriImgHeight) / 2
        this.diffY = 0
      }

      // Draw img into canvas
      if (val == 'rest') {
        ctx.drawImage(
          img,
          this.diffX,
          this.diffY,
          this.diffOri,
          this.diffOri,
          0,
          0,
          width,
          height
        )
      } else if (val == 'banner') {
        ctx.drawImage(
          img,
          this.diffX,
          this.diffY,
          this.oriImgWidth,
          this.oriImgHeight,
          0,
          0,
          width,
          height
        )
      }
      console.log(canvas)
      var dataURL = canvas.toDataURL('image/jpeg')

      console.log(dataURL)
      var imgAltName =
        fileInput.name.substr(0, fileInput.name.lastIndexOf('.')) + '.jpeg'
      const finalFile = this.base64toFile(imgAltName, dataURL)

      if (val == 'rest') {
        this.restLogo = URL.createObjectURL(finalFile)
        const id = new Date(Date.now()).getTime()
        const sltRestImgFile = {
          imgPath: dataURL,
          imgAlt: imgAltName,
          file: finalFile,
          id: id
        }
        this.sltRestImgFile = sltRestImgFile
      } else if (val == 'banner') {
        this.bannerImg = URL.createObjectURL(finalFile)
        const id = new Date(Date.now()).getTime()
        const sltBannerImgFile = {
          imgPath: dataURL,
          imgAlt: imgAltName,
          file: finalFile,
          id: id
        }
        this.sltBannerImgFile = sltBannerImgFile
      }

      this.loadingDialog = false
    },
    base64toFile(imgName, dataURL) {
      const byteString = atob(dataURL.split(',')[1])
      const mimeString = dataURL
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      const arrayBuffer = new ArrayBuffer(byteString.length)
      const int8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i)
      }
      const file = new File([arrayBuffer], imgName, { type: mimeString })
      return file
    },
    clearRestImg() {
      this.clearRestLogoDialog = true
    },
    clearBannerImg() {
      this.cleaBannerDialog = true
    },
    sureDltImg(val) {
      if (val == 'rest') {
        this.clearRestLogoDialog = false
        this.restLogo = ''
      } else if (val == 'banner') {
        this.errImgWithTran = ''
        this.cleaBannerDialog = false
        this.bannerImg = ''
      }
    },
    validEmail: function(email) {
      //eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    saveMchtConfig() {
      if (
        !this.validEmail(this.sCmpEmail.trim()) &&
        this.showCmpEmail == true &&
        globalVar.mode == 'lite'
      ) {
        this.getMchtConfigError = 'The Email must be a valid email address'
      } else {
        this.loadingDialog = true
        this.versionError = false
        if (this.showOption == true) {
          this.IOption = 0
          if (this.needPayment == true) {
            //console.log(0 | [enumEOrder_MchOption.NeedPayment])
            var IOption1 = 0 | [enumEOrder_MchOption.NeedPayment]
            this.IOption = this.IOption + IOption1
          }
          if (this.askLoginBeforeCheckout == true) {
            //console.log(0 | [enumEOrder_MchOption.AskLoginBeforeCheckout])
            var IOption2 = 0 | [enumEOrder_MchOption.AskLoginBeforeCheckout]
            this.IOption = this.IOption + IOption2
          }
          if (this.foodCourtMode == true) {
            //console.log(0 | [enumEOrder_MchOption.FoodCourtMode])
            var IOption3 = 0 | [enumEOrder_MchOption.FoodCourtMode]
            this.IOption = this.IOption + IOption3
          }
          if (this.ScanOrderMustEnterInfo == true) {
            //console.log(0 | [enumEOrder_MchOption.ScanOrderMustEnterInfo])
            var IOption4 = 0 | [enumEOrder_MchOption.ScanOrderMustEnterInfo]
            this.IOption = this.IOption + IOption4
          }
          console.log(this.IOption)
          this.sOption = this.IOption
        }

        this.sSvcPercent = JS.setToZero(this.sSvcPercent)
        this.sTaxPercent = JS.setToZero(this.sTaxPercent)
        this.sDeliveryChg = JS.setToZero(this.sDeliveryChg)
        this.sDepositMinAmt = JS.setToZero(this.sDepositMinAmt)
        this.sDepositPercent = JS.setToZero(this.sDepositPercent)

        let mchCode = sessionStorage.getItem('backendMchCode')
        let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
        var version = sessionStorage.getItem('version')
        const url = 'Back/EditMchtConfig'
        const parameter = {
          av: version,
          kp: mchCode,
          m: userInfo.UserId,
          ks: this.sAboutUs,
          kr: this.sTempleteUrl,
          ov: this.sPriceRateMsg,
          oe: this.sSvcPercent,
          od: this.sTaxPercent,
          jx: this.sChatAccHdrToken,
          bp: this.sUserAccToken,
          mo: this.sCanDineIn,
          mp: this.sCanTakeAway,
          mq: this.sCanDelivery,
          ok: this.sCanScanAndOrder,
          rs: this.sDeliveryChg,
          rt: this.sWAReplyMsg,
          ms: this.sDepositMinAmt,
          mt: this.sDepositPercent,
          oy: this.sRoundingType,
          ol: this.sOption,
          bl: this.locX,
          bm: this.locY,
          oz: this.sCmpName,
          ly: this.sCmpEmail,
          y: this.sCmpPh,
          en: this.sCmpAddress,
          sc: this.sCmpWeb,
          se: this.sBtnNameDineIn,
          sf: this.sBtnNameTakeAway,
          sg: this.sBtnNameDelivery,
          si: this.sBtnNameScanOrder,
          sh: this.sNoItemMsg
        }
        console.log(parameter)
        JS.request(url, parameter)
          .then(response => {
            console.log(response.data)
            if (
              response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
              response.data == 'Version Not Match'
            ) {
              this.versionError = true
            } else {
              this.versionError = false
              if (response.data.ht) {
                //this.loadingDialog = false
                this.getMchtConfigError = ''
                //this.recordSaveDialog = true
                sessionStorage.setItem('WAReplyMsg', this.sWAReplyMsg)
                sessionStorage.setItem(
                  'SchdTypeBtnName',
                  JSON.stringify({
                    DineIn: this.sBtnNameDineIn,
                    TakeAway: this.sBtnNameTakeAway,
                    Delivery: this.sBtnNameDelivery,
                    ScanOrder: this.sBtnNameScanOrder
                  })
                )
                sessionStorage.setItem('NoItemMsg', this.sNoItemMsg)

                //upload Image
                if (
                  this.restLogo != '' &&
                  this.restLogo != undefined &&
                  this.restLogo != null
                ) {
                  if (
                    this.bannerImg != '' &&
                    this.bannerImg != undefined &&
                    this.bannerImg != null
                  ) {
                    this.deleteRestLogo = false
                    this.deleteBanner = false
                    if (
                      this.restLogoFromServer != this.restLogo ||
                      this.bannerImgFromServer != this.bannerImg
                    ) {
                      this.uploadImg()
                    } else {
                      this.loadingDialog = false
                      this.recordSaveDialog = true
                    }
                  } else if (
                    this.bannerImg == '' ||
                    this.bannerImg == undefined ||
                    this.bannerImg == null
                  ) {
                    this.deleteRestLogo = false
                    this.deleteBanner = true
                    this.sltBannerImgFile = []
                    this.uploadImg()
                  }
                } else if (
                  this.restLogo == '' ||
                  this.restLogo == undefined ||
                  this.restLogo == null
                ) {
                  if (
                    this.bannerImg != '' &&
                    this.bannerImg != undefined &&
                    this.bannerImg != null
                  ) {
                    this.deleteRestLogo = true
                    this.deleteBanner = false
                    this.sltRestImgFile = []
                    this.uploadImg()
                  } else if (
                    this.bannerImg == '' ||
                    this.bannerImg == undefined ||
                    this.bannerImg == null
                  ) {
                    this.deleteRestLogo = true
                    this.deleteBanner = true
                    this.sltRestImgFile = []
                    this.sltBannerImgFile = []
                    this.uploadImg()
                  }
                }
              } else {
                this.loadingDialog = false
                this.getMchtConfigError = response.data
              }
            }
          })
          .catch(error => {
            console.log(error)
            this.loadingDialog = false
            this.versionError = false
            this.getMchtConfigError = error
          })
      }
    },
    uploadImg() {
      this.versionError = false

      let mchCode = sessionStorage.getItem('backendMchCode')

      const fileList = []
      var rImgFile = []
      var bnrImgFile = []
      console.log(this.sltBannerImgFile)
      if (this.sltRestImgFile != []) {
        rImgFile = { file: this.sltRestImgFile }
        //console.log(rImgFile)
      } else {
        rImgFile = []
      }
      if (this.sltBannerImgFile != []) {
        bnrImgFile = { file: this.sltBannerImgFile }
        //console.log(rImgFile)
      } else {
        bnrImgFile = []
      }
      bnrImgFile
      fileList.push(rImgFile)
      fileList.push(bnrImgFile)

      console.log(fileList)

      var version = sessionStorage.getItem('version')
      const url = 'Back/MchtImage'
      const parameter = {
        av: version,
        kp: mchCode,
        bq: this.deleteRestLogo,
        br: this.deleteBanner
      }
      console.log(parameter)

      JS.multipart(url, parameter, fileList, 'mchtConfig')
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ht) {
              this.loadingDialog = false
              this.getMchtConfigError = ''
              this.recordSaveDialog = true
            } else {
              this.loadingDialog = false
              this.getMchtConfigError = response.data
              this.versionError = false
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.versionError = false
          this.loadingDialog = false
          this.getMchtConfigError = error
        })
    }
  }
}
</script>

<style>
.inputTitle {
  font-size: 14px;
  margin-top: 10px;
}
.imgBorder {
  width: 100%;
  height: auto;
}
#infowindow-content .title {
  font-weight: bold;
}

#infowindow-content {
  display: none;
}

#map #infowindow-content {
  display: inline;
}

.pac-card {
  margin: 10px 10px 0 0;
  border-radius: 2px 0 0 2px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  outline: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  font-family: Roboto;
}

#pac-container {
  padding-bottom: 12px;
  margin-right: 12px;
}

.pac-controls {
  display: inline-block;
  padding: 5px 11px;
}

.pac-controls label {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 300;
}

#pac-input {
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 12px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 400px;
}

#pac-input:focus {
  border-color: #4d90fe;
}
</style>
